module.exports = function() {
  return new Worker(__webpack_public_path__ + "c84955377ebd7cecaf5a.worker.js");
};